export const aciCheckSimple = {
    iconName: 'check-simple',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 24' },
        path: {
            attr: {
                'clip-rule': 'evenodd',
                d: 'M8.248 20.882L1.617 14.25A2.96 2.96 0 015.8 10.064l4.218 4.218 7.9-10.533A2.96 2.96 0 0122.657 7.3L12.71 20.565a2.961 2.961 0 01-4.462.317z',
                stroke: 'currentColor',
                'stroke-width': '1.5',
                'stroke-linejoin': 'round',
            },
        },
    },
};
